import { ConnectorTypes } from '../Consts';
import logo from '../../../../images/cc/active_directory_logo.png';
import adIcon from '../../../../images/cc/ad-24x24.png';
import GeneralTab from './General';
import RulesTab from './Rules';

export default {
    identifier: ConnectorTypes.ACTIVE_DIRECTORY,
    name: 'Active Directory Connector',
    shortName: 'Active Directory',
    icon: adIcon,
    box: {
        logo,
        title: 'Microsoft Active Directory Connector',
        description:
            'Create users and groups in CyberFOX Password Manager directly from Active Directory',
    },
    tabs: [
        {
            name: 'general',
            label: 'General',
            component: GeneralTab,
        },
        {
            name: 'rules',
            label: 'Sync Rules',
            component: RulesTab,
        },
    ],
};
